import { MSerializers } from "@legacy-megarax/serializers";

export type DeliveryAddress = {
  name: string;
  locality: string;
  street: string;
  houseNumber: string;
  postalCode: string;
  country: string;
};

export const deliveryAddressSerializer = MSerializers.object<DeliveryAddress>({
  houseNumber: MSerializers.string,
  country: MSerializers.string,
  locality: MSerializers.string,
  name: MSerializers.string,
  postalCode: MSerializers.string,
  street: MSerializers.string,
});
